
export default "/assets/check-micro.1ace8bf4.svg"